// BlankShell — full-screen layout for chrome-less authenticated pages.
//
// Rendered as a layout route inside ProtectedRoute (sibling to AppShell).
// Used for the post-login HomePage where the module selector should fill
// the whole viewport with no sidebar, no topbar, and no nav of any kind.
// ToastContainer is intentionally omitted — surfaces that need toasts
// belong on the AppShell side.

import { Outlet } from 'react-router-dom';
import styles from './BlankShell.module.css';

export function BlankShell() {
  return (
    <div className={styles.shell}>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
